<template>
  <div>
    <a-result
      status="success"
      title="Dziękujemy!"
      subTitle="Sprawdź skrzynkę mailową i postępuj zgodnie ze wskazówkami"
    >
      <template v-slot:extra>
        <router-link to="/">
          <a-button type="primary" key="console"
            >Wróć na stronę logowania</a-button
          >
        </router-link>
      </template>
    </a-result>
  </div>
</template>

<script>
export default {
  name: 'success'
}
</script>

<style scoped>
.ant-result {
  padding: 0;
}
</style>
